import React from 'react'
import {  Routes, Route, useLocation } from "react-router-dom"
import Welcome from '../../pages/public/Welcome'
import AppointmentCalendar from '../../pages/hybrid/AppointmentCalendar';
import AppointmentManagement from '../../pages/private/AppointmentManagement';
import ServiceManagement from '../../pages/private/ServiceManagement';
import CreateService from '../../pages/private/CreateService';
import Login from '../../pages/public/Login';
import CreateAppointment from '../../pages/private/CreateAppointment';

export default function Router() {
    const location = useLocation();

    return (
        <Routes location={location} key={location.pathname}>
            <Route exact path="/" element={<Welcome />} />
            <Route path='/login' element={<Login />} />
            <Route exact path="/calendar" element={<AppointmentCalendar />} />
            <Route path="/appointment-management" element={<AppointmentManagement />} />
            <Route path="/appointment-management/create-appointment" element={<CreateAppointment />} />
            <Route path="/appointment-management/create-appointment/:id" element={<CreateAppointment />} />
            <Route path="service-management" element={<ServiceManagement />} />
            <Route path="service-management/create-service" element={<CreateService />} />
            <Route path="service-management/create-service/:id" element={<CreateService />} />
        </Routes>
    )
}
